<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <cobranza-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import CobranzaCrud from "./CobranzaCrud";
    export default {
        name: "Cobranza",
        components: {CobranzaCrud}
    }
</script>

<style scoped>

</style>

